export class ChallengeRequiredError extends Error {
  constructor(
    readonly challengeName: string,
    readonly challengeSession: string,
    readonly username: string,
    readonly tenantId: string,
  ) {
    super(challengeName);
    this.name = 'ChallengeRequiredError';
  }
}
